import { Modal } from '@sgcmpteltd/uikit-next';
import { Menu, MenuItem } from '@sgcmpteltd/uikit-react';
import cx from 'clsx';

import { MODAL_TRANSITION_DURATION_MS_DEFAULT } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const ModalWithMenuContent: Component = ({
  modalTitle,
  menuList,
  isOpen,
  transitionDurationMs = MODAL_TRANSITION_DURATION_MS_DEFAULT,
  onClose,
  className,
  contentClassName,
  titleClassName,
}) => {
  if (!menuList) {
    return (
      <Modal
        className={styles.containerRoot}
        contentClassName={styles.containerModalContent}
        isOpen={isOpen}
        title=""
        transitionDurationMs={transitionDurationMs}
        isBackdropStatic
        onClose={onClose} />
    );
  }

  return (
    <Modal
      className={cx(
        styles.containerRoot,
        className,
      )}
      contentClassName={cx(
        styles.containerModalContent,
        contentClassName,
      )}
      headerClassName={styles.containerHeader}
      isOpen={isOpen}
      title=""
      titleContainerClassName={styles.containerTitle}
      transitionDurationMs={transitionDurationMs}
      onClose={onClose}>
      <div className={cx(
        styles.textModelTitle,
        titleClassName,
      )}>
        {modalTitle}
      </div>
      <Menu className={cx(
        styles.menuRoot,
        styles.isBorderless,
      )}>
        {menuList.map(({ text, link }) => (
          <MenuItem
            key={`menu-${text}`}
            contentClassName={cx(
              styles.textMenuItem,
              styles.textRegularStyle,
            )}
            onClick={() => {
              window.open(
                `${link}`,
                '_blank',
                'noreferrer noopener',
              );
            }}>
            {text}
          </MenuItem>
        ))}
      </Menu>
    </Modal>
  );
};
